// @ts-nocheck
import React, { useEffect, useState } from 'react';
import CombinedStats from '../../common/CombinedStats';
import colours from '../../../constants/colours';
import { DateForFilter } from '../../../util/formatter';
import { scopes as tableScopes } from '../../../constants/scopes';
import { statsModes } from '../../../hooks/useAggregateStatsData';
import { useNavigate } from 'react-router-dom';

export interface GameStatsProps {
  id: string | undefined;
  stats: any;
  getData: () => Promise<any>;
}

function GameStats({ id, stats, getData }: GameStatsProps) {
  const navigate = useNavigate();

  const [_stats, _setStats] = useState<any[]>([]);
  useEffect(() => {
    if (stats) {
      _setStats([
        {
          colour: colours.STATS_OPEN_REQUESTS,
          linkto: `/requests/all?f_requestStatus=pending%20approval&${tableScopes.GAME}=${id}`,
          title: 'Open requests',
          metric: stats.openRequests,
          primaryStat: true,
        },
        {
          colour: colours.STATS_OVER_SLA,
          linkto: `/requests/all?${tableScopes.ISOVERSLA}=true&${tableScopes.GAME}=${id}`,
          title: 'Over SLA',
          metric: stats.overSLA,
          primaryStat: true,
        },
        {
          colour: colours.STATS_COMPLETED_REQUESTS,
          linkto: `/requests/all?f_requestStatus=authorised&${tableScopes.GAME}=${id}`,
          title: 'Complete requests',
          metric: stats.completeRequests,
        },
        {
          colour: colours.STATS_KEYS_IN_POOL,
          linkto: `/keys/game?${tableScopes.GAME}=${id}`,
          title: 'Keys in pool',
          metric: stats.keysAvailable,
        },
        {
          colour: colours.STATS_KEYS_DELIVERED,
          linkto: `/keys/game?${tableScopes.GAME}=${id}`,
          title: 'Keys delivered',
          metric: stats.keysAllocated,
        },
        {
          colour: colours.STATS_KEYS_DELIVERED_VALUE,
          linkto: `/keys/game?${tableScopes.GAME}=${id}`,
          title: 'Key delivered value',
          metric: stats.keyStockValue,
        },
        {
          colour: colours.STATS_KEYS_SOLD,
          linkto: `/keys/game?${tableScopes.GAME}=${id}`,
          title: 'Keys reported sold',
          metric: stats.keysSold,
        },
        {
          colour: colours.STATS_KEYS_DISABLED,
          linkto: `/keys/game?${tableScopes.GAME}=${id}`,
          title: 'Keys disabled',
          metric: stats.keysBlacklisted,
        },
        {
          colour: colours.STATS_KEYS_EXPIRED,
          linkto: `/keys/game?${tableScopes.GAME}=${id}`,
          title: 'Keys expired',
          metric: stats.keysExpired,
        },
        {
          colour: colours.STATS_ACCOUNTS,
          linkto: `/keys/accounts?${tableScopes.GAME}=${id}`,
          title: 'Accounts',
          metric: stats.accountsTotal,
        },
        {
          colour: colours.STATS_ACCOUNT_DOWNLOADED,
          linkto: `/keys/accounts?grouped=true&${tableScopes.GAME}=${id}&${tableScopes.ISDOWNLOADED}=true`,
          title: 'Accounts (downloaded)',
          metric: stats.accountsDownloadedKeys,
        },
      ]);
    }
  }, [id, stats]);

  return (
    <CombinedStats
      stats={_stats}
      getData={getData}
      setModeStorageKey={`game-stats-mode`}
      heatmapOnClick={(value: any) => {
        if (value) {
          let date = DateForFilter(value.date);
          let destination = `/requests/all?${tableScopes.GAME}=${id}&f_requestedDateFrom=${date}&f_requestedDateTo=${date}`;
          navigate(destination);
        }
      }}
      id={id}
      mode={statsModes.GAME}
    />
  );
}

export default GameStats;
